import { FormActions } from '../../Form'
import { UserInvitationFormModal } from '../UserInvitationFormModal'

import { QA_NAME_USER_STAFF_INVITATION_MODAL } from './UserStaffInvitationFormModal.constants'
import { getUserStaffInvitationFormInitialNotifications } from './UserStaffInvitationFormModal.utils'

// Staff invites go through the old `api/profile/invite/`, which sets the
// subject itself and never sends SMS.
function UserStaffInvitationFormModal({
  qaName = QA_NAME_USER_STAFF_INVITATION_MODAL,
  ...restProps
}) {
  return (
    <UserInvitationFormModal
      {...restProps}
      Actions={FormActions}
      SubjectField={null}
      getInitialNotifications={getUserStaffInvitationFormInitialNotifications}
      qaName={qaName}
    />
  )
}

export default UserStaffInvitationFormModal
